export default __webpack_public_path__ + "static/media/lb.c048318c.svg";